import React, { useState, useEffect } from 'react'
import Main from './component/Main'
import CampaignContainer, { Campaign } from './component/Campaign'
import { randomAnswers, addOrderToTheAnswer } from './utils/randomAnswers'
import survey from './utils/survey'

const dataLayer = window.dataLayer || [];

function App() {
  const [campaign, setCampaign] = useState<Campaign | undefined>()
  const [isMounted, setIsMounted] = useState<boolean>(false)
  
  const queryString = window.location.search
  const params = new URLSearchParams(queryString)
  const preview = params.get("preview")
  const isPreviewMode = !!preview

  useEffect(() => {
    if(isPreviewMode) {
      try {
        const previewCamaign: Campaign = JSON.parse(decodeURIComponent(preview || ''))
        const survey = previewCamaign
        const question = survey.q[0] // とりあえず1問しかないので0番目のqだけ撮ってくる
        const answerItems = addOrderToTheAnswer(question.random ? randomAnswers(question.a) : question.a)
  
        survey.q[0].a = answerItems
        setCampaign(survey)
        setTimeout(() => {
          setIsMounted(true)
        }, 0)
      } catch (e) {
        console.error(e)
      }
    } else {
      survey.ready()
      .then((data) => {
        data.survey.tokenId = data.tid
        data.survey.skipUrl = data.skp

        const survey = data.survey as Campaign
        const question = survey.q[0] // とりあえず1問しかないので0番目のqだけ撮ってくる
        const answerItems = addOrderToTheAnswer(question.random ? randomAnswers(question.a) : question.a)

        survey.q[0].a = answerItems

        setCampaign(survey)
        setTimeout(() => {
          setIsMounted(true)
          const campaign = survey
          dataLayer.push({
            event: 'view_ad_survey',
            uid: campaign.userId,
            token_id: campaign.tokenId,
            campaign_id: campaign.campaignId || 0,
            version: campaign.version || "1.0",
            question_page: question.page,
          })
        }, 3000)
      })
    }
  }, [isPreviewMode, preview])

  return (
    <Main className={isMounted ? 'on' : ''}>
      {campaign?.campaignId && <CampaignContainer isPreviewMode={isPreviewMode} {...campaign} />}
    </Main>
  )
}

export default App

/**
 * FIXME:
 * SIMID 関連のコードは IAB からコピーし，Abemaのドメインで再配布を行っている
 * SIMID の LICENSE は Appache License v2 であり，以下のCopyrightを記載しなければならない．
 * https://github.com/InteractiveAdvertisingBureau/SIMID/blob/406d27d7795ae210936f0d2e5c6416c0bf4d8a70/LICENSE#L178-L190
 * 現状コピーした SIMID 関連のコードに以下のライセンスを記載しても，react-script が
 * 書き出す xxxx.chunk.js.LICENSE に追記されない．
 * App.tsx に記載すると，xxxx.chunk.js.LICENSE に追記されるので，一旦 App.tsxに記載する
 */

/** @license
 *    Copyright 2021 IAB Technology Laboratory, Inc
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
